<template>
<div>
    <div class="table-show-header">
        <h4>Report processes</h4>
        <base-button icon type="info" @click="showReportProcesses=!showReportProcesses">
            <span class="btn-inner--icon">
                <i :class="{'ni ni-fat-add':!showReportProcesses, 'ni ni-fat-delete':showReportProcesses}" />
            </span>
        </base-button>
    </div>
    <div v-if="showReportProcesses">
        <h4 v-if="reportProcessesLoading">Loading...</h4>
        <div v-else>
            <base-button icon type="info" @click="getReportProcesses()">Refresh</base-button>
            <el-table class="table-responsive table"
                        header-row-class-name="thead-light"
                        :data="reportProcesses">
                <el-table-column label="UUID" prop="process_uuid" />
                <el-table-column label="Report ID" prop="report_id" />
                <el-table-column label="Report" prop="report_name" />
                <el-table-column label="Operation" prop="operation" />
                <el-table-column label="Status" prop="status" />
                <el-table-column label="Get results">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            <div v-if="row.completed">
                                <base-button v-if="row.operation_id==3 || row.operation_id==4" icon type="info" @click="getReportProcessResults(row,true)">
                                    Download
                                </base-button>
                                <base-button v-else icon type="danger" @click="getReportProcessResults(row,false)">
                                    Clear record
                                </base-button>
                            </div>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {Table,TableColumn} from 'element-ui'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const LocationReportRepository = RepositoryFactory.get('location_report');

export default {
    name:'report-process-view',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    data(){
        return{
            showReportProcesses:true,
            reportProcessesLoading:true,
            reportProcesses:null,
        }
    },
    created(){
        this.getReportProcesses();
    },
    methods:{
        parseReportProcess(reportProcess){
            reportProcess.operation=this.locationReportOperationMethodEnums[reportProcess.operation_id];
            return reportProcess
        },
        getReportProcesses(){
            this.reportProcessesLoading=true;
            LocationReportRepository.getReportProcesses().then((response) => {
                this.reportProcesses=response.data;
                for(var i in this.reportProcesses){
                    this.reportProcesses[i]=this.parseReportProcess(this.reportProcesses[i])
                }
                this.reportProcessesLoading=false;
            })
        },
        getReportProcessResults(reportProcess,download){
            LocationReportRepository.getReportProcessResults(reportProcess.process_uuid).then((response) => {
                if(download)
                    this.downloadExcelBlob(response,`${reportProcess.report_name}.xlsx`);
                this.getReportProcesses();
            })
        },
        addReportProcess(reportProcess){
            reportProcess=this.parseReportProcess(reportProcess);

            this.reportProcesses.push(reportProcess);
            this.$forceUpdate();
        }
    }
}
</script>

<style>

.table-show-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
    margin-top:10px;
    align-items: center;
    border-top: 1px solid;
    padding-top: 1rem;
    margin-bottom: .5rem;
    border-color: rgba(0, 0, 0, 0.05);
}

</style>